import apiClient from "utils/apiClient";
import { OLITASK_SERVICE_BASE_URL } from "constants";

const BASE = `${OLITASK_SERVICE_BASE_URL}/api/v1/profession-sectors`;

const unwrap = (r) => r?.data;

const list = () => apiClient.get(BASE).then(unwrap);

const getByCode = (code) =>
  apiClient.get(BASE, { params: { code } }).then(unwrap);

export const professionSectorService = {
  list,
  getByCode,
};

